module.exports = __webpack_public_path__ + "img/part5.aac6dea1.png";